import App from './App'
import store from './store'
import { createI18n } from 'vue-i18n';
import ResetPassword from '@/components/user/ResetPassword'
import InspectVehicle from '@/components/vehicle/InspectVehicle'
import WorkAssignmentsMobile from '@/components/workassignment/WorkAssignmentsMobile'
import { createWebHistory, createRouter } from 'vue-router'
import { createApp } from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {faLocation, faLocationPin, faNewspaper, fas, faUpRightFromSquare, faComments, faExpand, faCompress, faPaperPlane, faRobot, faHistory, faPlusCircle, faChevronLeft, faBackwardStep, faForwardStep} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import "bootstrap"
import './styles/custom-bootstrap.scss';

import {
    faAngleDoubleDown,
    faAngleDoubleUp,
    faArchway,
    faArrowCircleDown,
    faArrowCircleUp,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faBan,
    faBarcode,
    faBars,
    faBoxOpen,
    faBuilding,
    faCalendarCheck,
    faCamera,
    faCar,
    faCaretDown,
    faCaretRight,
    faCarSide,
    faCertificate,
    faChartLine,
    faCheck,
    faCheckCircle,
    faCheckSquare,
    faChevronDown,
    faChevronUp,
    faCircle,
    faClipboard,
    faClipboardCheck,
    faClipboardList,
    faClock,
    faCloudSun,
    faCog,
    faCogs,
    faCoins,
    faComment,
    faCopy,
    faCrosshairs,
    faDollyFlatbed,
    faDotCircle,
    faDrawPolygon,
    faEdit,
    faEnvelopeOpenText,
    faEuroSign,
    faExclamation,
    faExclamationCircle,
    faExclamationTriangle,
    faEye,
    faFileCirclePlus,
    faFileContract,
    faFileCsv,
    faFileInvoice,
    faFilter,
    faFlag,
    faHandsHelping,
    faHardHat,
    faHatWizard,
    faHelicopter,
    faIndustry,
    faInfoCircle,
    faLightbulb,
    faList,
    faLock,
    faMap,
    faMapMarker,
    faMapPin,
    faMinus,
    faMinusSquare,
    faMoneyCheck,
    faPaintBrush,
    faPaperclip,
    faPause,
    faPlay,
    faPlayCircle,
    faPrint,
    faQuestion,
    faQuestionCircle,
    faRoad,
    faRoute,
    faRulerHorizontal,
    faSearch,
    faSkiingNordic,
    faSnowplow,
    faSquare,
    faTablet,
    faTachometerAlt,
    faTasks,
    faTicketAlt,
    faTimes,
    faTimesCircle,
    faTractor,
    faTrailer,
    faTrash,
    faTruck,
    faTruckMonster,
    faTruckMoving,
    faUser,
    faUsers,
    faUserTie,
    faVideo,
    faWarehouse,
    faWaveSquare,
    faWrench,
    faCloudUploadAlt,
    faStar,
    faPlus,
    faPlug,
    faFilePdf,
    faAngleDoubleLeft,
    faChevronRight,
    faArrowRightFromBracket,
    faSortUp,
    faSortDown,
    faVideoCamera
} from '@fortawesome/free-solid-svg-icons'
// Add Font Awesome icons
library.add(
    faPlus,
    faMinus,
    faMinusSquare,
    faBars,
    faTachometerAlt,
    faTruck,
    faUsers,
    faUserTie,
    faUser,
    faMap,
    faMapPin,
    faCog,
    faCogs,
    faCheckSquare,
    faClipboardCheck,
    faClipboardList,
    faExclamationTriangle,
    faCalendarCheck,
    faCoins,
    faMoneyCheck,
    faFileContract,
    faFileInvoice,
    faArrowDown,
    faRoad,
    faCar,
    faDrawPolygon,
    faRoute,
    faHandsHelping,
    faQuestionCircle,
    faTruckMonster,
    faTruckMoving,
    faCarSide,
    faExclamationCircle,
    faCarSide,
    faBan,
    faCheck,
    faWrench,
    faPrint,
    faClipboard,
    faEye,
    faMapMarker,
    faBarcode,
    faClock,
    faSquare,
    faVideo,
    faPlayCircle,
    faTicketAlt,
    faSearch,
    faEdit,
    faTrash,
    faCertificate,
    faCheckCircle,
    faQuestion,
    faExclamation,
    faPaperclip,
    faTasks,
    faAngleDoubleUp,
    faAngleDoubleDown,
    faCrosshairs,
    faInfoCircle,
    faCaretDown,
    faSkiingNordic,
    faSnowplow,
    faHelicopter,
    faTablet,
    faCopy,
    faWarehouse,
    faBoxOpen,
    faIndustry,
    faHardHat,
    faArrowLeft,
    faArrowRight,
    faEnvelopeOpenText,
    faLock,
    faList,
    faBuilding,
    faTimesCircle,
    faArrowCircleDown,
    faTractor,
    faTrailer,
    faDollyFlatbed,
    faRulerHorizontal,
    faArrowUp,
    faDotCircle,
    faArchway,
    faCloudSun,
    faEuroSign,
    faFileCsv,
    faComment,
    faWaveSquare,
    faTimes,
    faCircle,
    faArrowCircleUp,
    faFilter,
    faCaretRight,
    faLightbulb,
    faChartLine,
    faHatWizard,
    faPaintBrush,
    faPlay,
    faPause,
    faFlag,
    faCamera,
    faChevronUp,
    faChevronDown,
    faCloudUploadAlt,
    faStar,
    faPlug,
    faFilePdf,
    faAngleDoubleLeft,
    faChevronRight,
    faArrowRightFromBracket,
    faSortUp,
    faSortDown,
    faUpRightFromSquare,
    faLocationPin,
    faNewspaper,
    faComments,
    faExpand,
    faCompress,
    faPaperPlane,
    faRobot,
    faHistory,
    faPlusCircle,
    faChevronLeft,
    faFileCirclePlus,
    faVideoCamera,
    faBackwardStep,
    faForwardStep
)
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import '@bhplugin/vue3-datatable/dist/style.css';


import '@vuepic/vue-datepicker/dist/main.css'
import TempOffice from "./components/TempOffice";
import ResetPasswordRequest from "./components/user/ResetPasswordRequest";
import en from './locales/en.json';
import fi from './locales/fi.json';
import sv from './locales/sv.json';

const i18n = createI18n({
    legacy: false, // Important for Vue 3 Composition API
    locale: 'en',  // Default language
    fallbackLocale: 'en',
    messages: { en, fi, sv  }
});

library.add(fas)

const app = createApp(App)
app.use(i18n);
app.use(createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            name: 'TempOffice',
            component: TempOffice
        },
        {
            path: '/resetPassword',
            name: 'ResetPassword',
            component: ResetPassword
        },
        {
            path: '/#/workAssignment',
            name: 'WorkAssignmentsMobile',
            component: WorkAssignmentsMobile
        }
    ]
}))
app.use(store)
app.component('Multiselect', Multiselect)
app.component('FontAwesomeIcon', FontAwesomeIcon)
app.mount('#app')
